<template>
  <div v-if="isShowSidebar" class="sidebar">
    <a class="sidebar-item" rel="nofollow" :href="t('sidebar.aiCEOLink')" target="_blank">
      <img class="icon no-border" src="@/assets/images/icon/icon-ai-ceo.png" :alt="t('sidebar.aiCEO')" />
      <p class="text">{{ t('sidebar.aiCEO') }}</p>
    </a>
    <a class="sidebar-item" rel="nofollow" @click="openAi">
      <img class="icon no-border" src="@/assets/images/icon/icon-ai.png" :alt="t('sidebar.aiService')" />
      <p class="text">{{ t('sidebar.aiService') }}</p>
    </a>
    <a class="sidebar-item" rel="nofollow" :href="t('sidebar.visitorBadgeLink')" target="_blank">
      <div class="icon">
        <img src="@/assets/images/icon/icon-ticket.svg" :alt="t('sidebar.visitorBadge')" />
      </div>
      <p class="text">{{ t('sidebar.visitorBadge') }}</p>
    </a>
    <a class="sidebar-item" rel="nofollow" :href="t('sidebar.boothBookingLink')" target="_blank">
      <div class="icon purple">
        <img src="@/assets/images/icon/icon-sofa.svg" :alt="t('sidebar.boothBooking')" />
      </div>
      <p class="text">{{ t('sidebar.boothBooking') }}</p>
    </a>
    <a class="sidebar-item" rel="nofollow" :href="t('sidebar.emailSubscriptionLink')" target="_blank">
      <div class="icon">
        <img src="@/assets/images/icon/icon-email.svg" :alt="t('sidebar.emailSubscription')" />
      </div>
      <p class="text">{{ t('sidebar.emailSubscription') }}</p>
    </a>
    <!-- <a class="sidebar-item to-top" rel="nofollow" @click="toTop">
      <div class="icon">
        <img src="@/assets/images/icon/icon-scroll-to-top.svg" alt="回到顶部" />
      </div>
      <p class="text">回到顶部</p>
    </a> -->
    <el-drawer v-model="isShowAiDrawer" custom-class="ai-drawer" append-to-body :with-header="false">
      <iframe class="ai-drawer-iframe"
        :src="`https://chatbot.exporeg.cn/chatbot_v2/#/ai/chats?bot_id=7617800775309901878&user_id=${sessionId}`"
        frameborder="0"></iframe>
    </el-drawer>
  </div>
  <div class="chat" @click="isShowSidebar = !isShowSidebar">
    <img src="@/assets/images/icon/icon-chat.svg" alt="chat">
  </div>
</template>

<script setup>
import { ref } from "vue";
import Cookies from "js-cookie";
import { getChatBotUserId } from "@/api/common";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const isShowSidebar = ref(false);
const sessionId = ref(Cookies.get("sessionId"));
const isShowAiDrawer = ref(false);

const openAi = async () => {
  try {
    if (!sessionId.value) {
      const res = await getChatBotUserId();
      sessionId.value = res.data || '';
      Cookies.set("sessionId", sessionId.value, { expires: 7 });
    }
  } catch (error) {
    console.log(error);
  } finally {
    isShowAiDrawer.value = true;
  }
}

const toTop = () => {
  window?.scrollTo?.({
    top: 0,
    behavior: 'smooth'
  })
}
</script>

<style scoped lang="less">
.sidebar {
  position: fixed;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #ffffff;
  border-radius: 999px;
  box-shadow: 0 0 10px 0 rgba(225, 27, 28, 0.1);
  z-index: 10;
  padding: 8px;

  .sidebar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    padding: 10px 0;

    &:not(:last-child) {
      border-bottom: 1px solid #efefef;
    }

    .purple {
      &.icon {
        border-color: #CF5BDC;
      }
    }

    &:hover {
      opacity: 0.6;
    }

    &.to-top {
      gap: 0;

      .icon {
        border: none;
      }

      .text {
        color: #B1B1B1;
      }
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #FF6F70;
      object-fit: contain;

      &.no-border {
        border: none;
        border-radius: 0;
      }

      img {
        width: 50%;
        aspect-ratio: 1 / 1;
        object-fit: contain;
        object-position: center;
      }
    }

    .text {
      color: #333333;
      font-size: 14px;
      text-align: center;
      line-height: 24px;
    }
  }
}

.chat {
  position: fixed;
  right: 10px;
  bottom: 80px;
  width: 60px;
  height: 60px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 100;
  padding: 20px;

  img {
    width: 100%;
  }
}

@media screen and (max-width: 920px) {
  .sidebar {
    .sidebar-item {
      gap: 4px;
      padding: 6px 0;

      .icon {
        width: 30px;
        height: 30px;
      }

      .text {
        font-size: 12px;
      }
    }
  }
}
</style>

<style lang="less">
.ai-drawer {
  width: 30% !important;

  .el-drawer__body {
    padding: 0;
  }
}

.ai-drawer-iframe {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

.el-popup-parent--hidden {
  height: 100vh;
  overflow: hidden;
}

@media screen and (max-width: 920px) {
  .ai-drawer {
    width: 80% !important;
  }
}
</style>
